<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            plain
            @click.stop="handleAdd(scope.row,scope.index)"
          >新增</el-button>
          <el-button
            type="warning"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_SERVICE_WARRANTY"
            @click.stop="handleDel('DELETE_OPTION','逻辑删除')"
          >删除</el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            v-if="permission.JOINS_SALES_CLOUD_WORK_SERVICE_WARRANTY"
            @click.stop="handleDel('DELETE_OPTION','物理删除')"
          >物理删除</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="success"
            size="small"
            icon="el-icon-view"
            plain
            @click.stop="handleView(scope.row,scope.index)"
          >查看</el-button>
        </template>
        <template slot="search">
          <el-form-item
            label="服务类目名称"
            size="small"
            style="margin-top: 4px"
          >
            <el-col :md="32">
              <el-select
                v-model="superiorId"
                placeholder="请选择服务类目名称"
                width="200"
                value-key="id"
                clearable
                @change="selectSuperiorId"
              >
                <el-option
                  v-for="item in superiorIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item
            label="服务项目名称"
            size="small"
            style="margin-top: 4px"
          >
            <el-col :md="32">
              <el-select
                v-model="serviceCategoryName"
                placeholder="请选择服务项目名称"
                width="300"
                clearable
                value-key="id"
              >
                <el-option
                  v-for="item in categoryTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <template
          slot-scope="scope"
          slot="images"
        >
          <!-- <viewer :images="formmaterImage(scope.row.images)">
            <img
              v-for="src in formmaterImages(scope.row.images)"
              :src="src"
              :key="src"
              width="20"
            >
          </viewer> -->
          <viewer>
            <img
              v-for="src in formmaterImages(scope.row.images)"
              :src="src"
              :key="src"
              @click='changeImage(scope.row.images)'
              width="20"
            >
          </viewer>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { serviceWarrantyOption } from "@/const/work/serviceWarrantyOption";
import { findGuarantee, delItem } from "@/api/work/serviceWarranty";
import { findProject } from "@/api/work/serviceItem";
import { Image } from "element-ui";
export default {
  name: "serviceWarranty",
  data() {
    return {
      tableOption: serviceWarrantyOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      superiorIds: [],
      superiorId: {},
      serviceCategoryName: {},
      categoryTypes: [],
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      url:
        "http://joinstech-public.oss-cn-shenzhen.aliyuncs.com/7de80e574b428d8e6bc68663e33e1f60,https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      list: [],
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    findProject().then(res => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e.id;
      findProject(params).then(res => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
        this.serviceCategoryName = {};
      });
    },
    changeImage(row) {
      console.log(row);
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        // let picArray = row.split(",");
        let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      this.list = str;
    },
    formmaterImages(row) {
      let arr = [];
      arr.push(row[0]);
      // if (this.list != null) {
      //   console.log(this.list);
      //   arr = this.list;
      // } else {
      //   console.log(this.list);
      //   arr.push(row[0]);
      // }
      return row;
    },

    formmaterImage(row) {
      let str = new Array();
      //   console.log("row：" + JSON.stringify(row));
      // JSON.stringify(row);
      if (row != null) {
        // let picArray = row.split(",");
        let picArray = row;
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
      this.superiorId = {};
      this.serviceCategoryName = {};
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findGuarantee(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findGuarantee(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.superiorId = "";
      if (this.superiorId.id != undefined) {
        params.superiorId = this.superiorId.id;
      }
      params.id = "";
      if (this.serviceCategoryName.id != undefined) {
        params.id = this.serviceCategoryName.id;
      }
      console.log(params);
      findGuarantee(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      findGuarantee(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增服务质保",
        value: "serviceWarranty/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
    },
    handleEdit(row, index) {
      console.log(row, index);
      let obj = {
        label: "编辑服务质保",
        value: "serviceWarranty/edit",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleView(row, index) {
      console.log(row, index);
      let obj = {
        label: "查看服务质保",
        value: "serviceWarranty/view",
        query: { id: row.id, aname: row.name }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findGuarantee(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delItem(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      editTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
